// extracted by mini-css-extract-plugin
export default {"container":"hF58fHdcGjN6iNsN7GWlqA==","information":"u3mUwJrVgNavzgRFFXhEKQ==","titleContainer":"zMFgPdEw96YE1G-16rw26w==","dateContainer":"nxBvePISRCLx8KDPCYJCQQ=="};